import React from 'react';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  return (
    <div className={["flex justify-center items-center", className].filter(Boolean).join(' ')}>
      <div className={[
        'animate-spin',
        'rounded-full',
        'border-2',
        'border-gray-300',
        'border-t-primary-600',
        sizeClasses[size]
      ].filter(Boolean).join(' ')} />
    </div>
  );
};

export default LoadingSpinner;